export const capitalize: (str: string) => string = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
